// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;May he live as long as the sun and moon endure,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;from one generation to another.<br> </p> </div></div>";
// Exports
module.exports = code;